import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { QuestionnaireGroup } from '@mona/models';
import { QuestionnaireGroupsState } from '../../entities';
import * as QuestionnaireGroupsActions from '../actions/questionnaire-groups.actions';

/** EntityAdapter<QuestionnaireGroup> */
export const questionnaireGroupsAdapter: EntityAdapter<QuestionnaireGroup> = createEntityAdapter<QuestionnaireGroup>({
    selectId: (group: QuestionnaireGroup) => group.id || group.navigationUrl,
    sortComparer: (a, b) => a.order - b.order,
});

const initialState: QuestionnaireGroupsState = questionnaireGroupsAdapter.getInitialState({
    error: null,
    isLoading: false,
});

export const questionnaireGroupsReducer = createReducer(
    initialState,
    on(QuestionnaireGroupsActions.loadQuestionnaireGroups, state => ({
        ...state,
        error: null,
        isLoading: true,
    })),
    on(QuestionnaireGroupsActions.loadQuestionnaireGroupsSuccess, (state, { questionnaireGroups }) => ({
        ...questionnaireGroupsAdapter.setAll(questionnaireGroups, state),
        error: null,
        isLoading: false,
    })),
    on(QuestionnaireGroupsActions.loadQuestionnaireGroupsFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),
    on(QuestionnaireGroupsActions.clearQuestionnaireGroups, state => ({
        ...questionnaireGroupsAdapter.removeAll(state),
        error: null,
        isLoading: false,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = questionnaireGroupsAdapter.getSelectors();
